function languageCandidates(expressions, language) {
  return (expressions || []).filter((expression) => expression.language === language);
}

function preferredInLanguage(expressions, language) {
  const candidates = languageCandidates(expressions, language);
  return candidates.find((item) => item.reading_available === true)
    || candidates.find((item) => item.reading_available == null)
    || candidates[0]
    || null;
}

export function selectExpressionId(expressions, requestedId = "", language = "") {
  const items = expressions || [];
  const requested = items.find((item) => item.expression_id === requestedId);
  if (requested) {
    if (requested.reading_available !== false) return requested.expression_id;
    return languageCandidates(items, requested.language)
      .find((item) => item.expression_id !== requestedId && item.reading_available === true)
      ?.expression_id || requested.expression_id;
  }
  if (requestedId) return requestedId;
  return preferredInLanguage(items, language)?.expression_id || "";
}

export function selectParallelExpressionIds(expressions, requestedId = "") {
  const items = expressions || [];
  const requested = items.find((item) => item.expression_id === requestedId);
  return {
    th: selectExpressionId(items, requested?.language === "th" ? requestedId : "", "th") || null,
    en: selectExpressionId(items, requested?.language === "en" ? requestedId : "", "en") || null,
  };
}

export function preferredExpressionId(expressions, requestedId = "", language = "", fallbackLanguage = "") {
  const items = expressions || [];
  const requested = items.find((item) => item.expression_id === requestedId);
  if (requestedId && !requested) return requestedId;
  const requestedMatchesLanguage = requested && requested.language === language;
  const selectedId = selectExpressionId(
    items,
    requestedMatchesLanguage ? requestedId : "",
    language,
  );
  if (requestedMatchesLanguage) return selectedId;
  return selectedId
    || selectExpressionId(items, "", fallbackLanguage)
    || items[0]?.expression_id
    || requestedId
    || "";
}
